export function Tiktok() {
  return (
<svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.0725 0H13.0278V16.3478C13.0278 18.2956 11.4722 19.8957 9.53625 19.8957C7.60035 19.8957 6.0447 18.2956 6.0447 16.3478C6.0447 14.4348 7.56575 12.8695 9.43255 12.8V8.69565C5.3187 8.7652 2 12.1391 2 16.3478C2 20.5913 5.38785 24 9.57085 24C13.7537 24 17.1416 20.5565 17.1416 16.3478V7.9652C18.6628 9.07825 20.5295 9.73915 22.5 9.77395V5.66955C19.4578 5.5652 17.0725 3.06086 17.0725 0Z" fill="currentColor"/>
</svg>
  );
}
